module.exports = __webpack_public_path__ + "img/gr0-logo.e7670bbd.png";